import { PAGE_LEVEL } from '@/constants';

export default {
  meta: { localeModules: ['roadshow'] },
  //路演
  path: '/roadshow',
  redirect: '/roadshow/list',
  children: [
    {
      // 路演活动
      path: 'list',
      name: 'roadshowIndex',
      component: () => import(/* webpackChunkName: 'roadshow-list' */ '@/pages/roadshow/list.vue'),
      meta: {
        name: 'routers.roadshow_roadshow',
        componentName: 'RoadshowListIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    },
    {
      // 路演详情
      path: 'detail',
      name: 'roadshowDetail',
      component: () => import(/* webpackChunkName: 'roadshow-detail' */ '@/pages/roadshow/detail.vue'),
      meta: {
        parent: '/roadshow/list',
        // 其他父级页面
        otherParent: [
          '/scheduleManage/list',
          '/globalSearch/index',
          '/find/list',
          '/manage/profile',
          '/find/self-selected'
        ]
      }
    },
    {
      // 智能纪要页面
      path: 'aiSummary',
      name: 'aiSummary',
      component: () => import(/* webpackChunkName: 'ai-summary' */ '@/pages/roadshow/aiSummaryDetail.vue'),
      meta: {
        name: 'routers.roadshow_ai_summary',
        parent: '/roadshow/list'
      }
    }
  ]
};
